module.exports = __webpack_public_path__ + "img/goods9_6.d768126d.jpg";